var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5915 5.29316C13.9824 4.90228 14.6161 4.90228 15.007 5.29316C15.3979 5.68405 15.3979 6.3178 15.007 6.70869L8.7073 13.0084C8.31678 13.3989 7.68361 13.3989 7.29309 13.0084L0.99336 6.70869C0.602474 6.3178 0.602474 5.68405 0.99336 5.29316C1.38425 4.90228 2.018 4.90228 2.40888 5.29316L8.0002 10.8845L13.5915 5.29316Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.35d2f3c2501a3e04e84d01a1773112ec.svg";
export { ForwardRef as ReactComponent };